import React, {useEffect, useState} from 'react';
import lazyWithPreload from 'lazy-with-preload';
import styles from './Ad.module.scss';
import {IAuthenticatedPageProps} from 'gui/components/authenticatedPage/AuthenticatedPage';
import {IProduct} from 'data/interfaces/products';
import {
  hotelDetails,
  identifyProductCategoryType,
  ticketDetails,
  vacationDetails,
  voucherDetails
} from 'data/redux/constants/productsConstants';
import {IUser} from 'data/redux/reducers/authenticationReducer';
import {ITransaction} from 'data/interfaces/transactions';
import {IOrder, IOrderOptions} from 'data/interfaces/orders';
import LoaderContainer from 'data/redux/containers/LoaderContainer/LoaderContainer';
import {If, Then} from 'react-if';
import {Route, Switch} from 'react-router';
import {linksMap} from 'data/utils/constants';
import EditProductContainer from 'data/redux/containers/editProductContainer';
import {generateSluggedAdUrl} from 'data/redux/actions/guiActions';
import AdControlTopLineContainer from 'data/redux/containers/adControlTopLineContainer/AdControlTopLineContainer';
import ScrollToTopExtended from 'gui/components/scrollToTopExtended/ScrollToTopExtended';
import AdLoading from 'gui/pages/mainRouter/pages/ad/components/adLoading';
import CrispChatContainer from 'data/redux/containers/crispChatContainer';
import {generateFlightTitle} from "./components/adFlight";
import {generateHotelTitle} from 'gui/components/listPage/components/ad/components/adHotel/AdHotel';
import {generateVoucherTitle} from 'gui/components/listPage/components/ad/components/adVoucher/AdVoucher';
import {generateAdVacationTitle} from 'gui/components/listPage/components/ad/components/adVacation/AdVacation';

/**
 import AdHotel from './components/adHotel/AdHotel';
 import AdVoucher from './components/adVoucher/AdVoucher';
 import AdFlight from './components/adFlight/AdFlight';
 import AdVacation from './components/adVacation/AdVacation';
 */

const AdHotel = lazyWithPreload(() => import(/* webpackChunkName: "AdHotel" , webpackMode:'lazy' */ './components/adHotel/AdHotel'));
const AdVoucher = lazyWithPreload(() => import(/* webpackChunkName: "AdVoucher" , webpackMode:'lazy' */ './components/adVoucher/AdVoucher'));
const AdFlight = lazyWithPreload(() => import(/* webpackChunkName: "AdFlight" , webpackMode:'lazy' */ './components/adFlight/AdFlight'));
const AdVacation = lazyWithPreload(() => import(/* webpackChunkName: "AdVacation" , webpackMode:'lazy' */ './components/adVacation/AdVacation'));

interface IAdProps extends IAuthenticatedPageProps {
  product?: IProduct;
  order?: IOrder;
  transaction?: ITransaction;
  user?: IUser;
  id?: number;
  slug?: string;
  allowNavigation?: boolean;
  isProductOwner?: boolean;
  isOrderOwner?: boolean;
  loadProduct?: () => Promise<any>;
  beginOrder?: (product: IProduct, options: IOrderOptions) => Promise<void>;
  loadAdPage?: (id: number, slug?: string) => Promise<IProduct>;
  loadAllOrdersToProduct?: (product_id: number) => Promise<IOrder[]>;
  loadAllOrdersByMe?: () => Promise<any>;
  autoFixSlug?: (product: IProduct) => Promise<IProduct>;
}

const getProductPageComponentByType = (props: Partial<IAdProps>) => {
  switch (identifyProductCategoryType(props.product)) {
    case ticketDetails:
      return AdFlight;
    case hotelDetails:
      return AdHotel;
    case vacationDetails:
      return AdVacation;
    case voucherDetails:
      return AdVoucher;
  }
  return (null);
}

export const getProductTitle = (props: Partial<IAdProps>) => {
  switch (identifyProductCategoryType(props.product)) {
    case ticketDetails:
      return generateFlightTitle(props);
    case hotelDetails:
      return generateHotelTitle(props);
    case vacationDetails:
      return generateAdVacationTitle(props);
    case voucherDetails:
      return generateVoucherTitle(props);
  }
  return ('');
}

export const selectProductType = (props: IAdProps) => {
  const ProductPageComponent = getProductPageComponentByType(props);
  if (ProductPageComponent) {
    return (<ProductPageComponent {...props} />);
  }
  return (<div/>);
}

const preloadProductPage = product => {
  const ProductPageComponent = getProductPageComponentByType({product} as any);
  if (ProductPageComponent) {
    return ProductPageComponent
      .preload()
      .then(() => product);
  }
  return product;
}
/*
const debugData = [];
function compareObjects(obj1, obj2) {
  const differences = [];

  for (const key in obj1) {
    if (!(key in obj2)) {
      differences.push({ key, type: "missing", value: obj1[key] });
    } else if (typeof obj1[key] === "object" && typeof obj2[key] === "object") {
      const nestedDifferences = compareObjects(obj1[key], obj2[key]);
      differences.push(...nestedDifferences.map(d => ({ key: key + "." + d.key, ...d })));
    } else if (obj1[key] !== obj2[key]) {
      differences.push({ key, type: "different", value1: obj1[key], value2: obj2[key] });
    }
  }

  for (const key in obj2) {
    if (!(key in obj1)) {
      differences.push({ key, type: "extra", value: obj2[key] });
    }
  }

  return differences;
}

function addObjectAndCompare(newObject) {
  // Limit the debugData array to 10 elements
  if (debugData.length >= 10) {
    debugData.shift();
  }

  // Add the new object to the debugData array
  debugData.push(newObject);

  // If there are at least two elements, compare the last two objects
  if (debugData.length > 1) {
    const lastIndex = debugData.length - 1;
    const differences = compareObjects(debugData[lastIndex], debugData[lastIndex - 1]);

    if (differences.length > 0) {
      console.log('Differences:', differences);
    }
  }
}
*/



const Ad = (props: IAdProps) => {
 // addObjectAndCompare(props);
  const [isFetchingProduct, setFetchingProduct] = useState(false);
  const [nextEditorRef, setNextEditorRef] = useState(true);
  const loadProduct = () => {
    setFetchingProduct(true);
    return props.loadAdPage(props.id)
      .then(product => props.loadAllOrdersToProduct(product.id).then(() => product))
      .then(preloadProductPage)
      .then((product) => props.autoFixSlug(product))
      .catch(e => {
        
        return Promise.resolve();
      })
      .then(s => {
        setFetchingProduct(false);
      });
  };
  useEffect(() => {
    if (!isFetchingProduct && props.id && props.allowNavigation && props.product && props.product.id !== props.id) {
      loadProduct();
    }
  }, [props.allowNavigation, props.product, props.id]);
  return (
    <>
      <AdControlTopLineContainer nextEditorRef={nextEditorRef}/>
      <section className={`container-xl ${styles.AdContainer}`}>
        <CrispChatContainer/>
        <ScrollToTopExtended
          bottom={95}
          scollOnChange={JSON.stringify({
            orderStatus: (props.order || {}).status,
            productStatus: (props.product || {}).status
          })}
          scrollOnRender smooth/>
        <LoaderContainer
          ignoreRedux={true}
          loading={isFetchingProduct || !props.product || props.product.id !== props.id || !props.product.productIdentifier}
          loadingPlaceholder={
            <AdLoading/>}
        >
          <Switch>
            <Route exact path={linksMap.adIdSlug}>
              <If condition={props.product.id === props.id}>
                <Then>{() =>
                  selectProductType({...props, loadProduct})
                }</Then>
              </If>
            </Route>
            <Route exact path={linksMap.adEditIdSlug}>
              <EditProductContainer onSubmitRedirectTo={generateSluggedAdUrl(props.product)}
                                    setSubmitRef={r => setNextEditorRef(r)}/>
            </Route>
          </Switch>
        </LoaderContainer>
      </section>
    </>
  );
};

Ad.defaultProps = {
  product: {},
  loadAdPage: (id, slug) => new Promise(resolve => resolve({id, slug})),
  loadAllOrdersToProduct: (product_id) => new Promise(resolve => resolve([])),
  loadAllOrdersByMe: (id, slug) => new Promise(resolve => resolve({id, slug})),
  autoFixSlug: (product) => new Promise(resolve => resolve({product})),
};

export default Ad;
